import React, { useState } from "react";
import { Grow, Table, TableHead, TableBody, TableCell, TableRow, Grid, TableContainer, TablePagination } from "@mui/material";
import { useTranslation } from "react-i18next";

const tableCellStyle = { color: "#222" };

export default function SparePartTable(props) {
    const { t } = useTranslation("translation");

    //pagination
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    return (
        <Grid container item md={12}>
            {/*Empty grid for alignment*/}
            {props.warningList.length <= 0 ? <Grid item xs={1} sm={3} md={2}></Grid> : <Grid item md={1}></Grid>}
            <Grid item xs={10} sm={6} md={7}>
                <div style={{ overflow: "auto", height: "auto" }}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">{t("ID")}</TableCell>
                                <TableCell align="center">{t("StockNo")}</TableCell>
                                <TableCell align="center">{t("MaterialDescription")}</TableCell>
                                <TableCell align="center">{t("Unit")}</TableCell>
                                <TableCell align="center">{t("Department")}</TableCell>
                                <TableCell align="center">{t("WareHouseQuantity")}</TableCell>
                                <TableCell align="center">{t("ShelfNo")}</TableCell>
                                <TableCell align="center">{t("MinimumStockQuantity")}</TableCell>
                                <TableCell align="center">{t("PlaceToCount")}</TableCell>
                                <TableCell align="center">{t("Description")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.sparePartExcel.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                <TableRow style={{ background: row.hasWarning ? "#FF9089" : "aliceblue" }}>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.excelRowNumber}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.materialCode}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.materialDescription}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.unit}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.department}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.stockQuantity}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.shelfNo}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.minimumStockQuantity}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.countingPlace}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.description}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        id="sp_TablePagination"
                        rowsPerPageOptions={[5, 10, 15]}
                        component="div"
                        count={props.sparePartExcel.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </div>
            </Grid>
            <Grid container xs={2} sm={6} md={4}>
                {props.warningList.length > 0 && props.sparePartExcel.length > 0 ? (
                    <>
                        <Grid item md={1}></Grid>
                        <Grid item md={8}>
                            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                                <TableContainer style={{ backgroundColor: "#FF9089" }}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">{t("Line")}</TableCell>
                                                <TableCell align="center">{t("Warnings")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {props.warningList.map((row) => (
                                                <TableRow>
                                                    <TableCell sx={tableCellStyle} align="center">
                                                        {row.rowNumber - 1}
                                                    </TableCell>
                                                    <TableCell sx={tableCellStyle} align="center">
                                                        {row.message}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grow>
                        </Grid>
                        <Grid item md={1}></Grid>
                    </>
                ) : null}
            </Grid>
            {/*Empty grid for alignment*/}
        </Grid>
    );
}
